export interface EDCategory {
  // DB Fields
  uid: number;
  companyUID: number;
  parentUID: number;
  name: string;
  depth: number;
  isDeleted: boolean;

  // NOT DB
  subCategories: EDCategory[];
}

export const initialEDCategory = {
  // DB Fields
  uid: 0,
  companyUID: 0,
  parentUID: 0,
  name: "",
  depth: 0,
  isDeleted: false,

  // NOT DB
  subCategories: [] as EDCategory[],
};

export interface EDCategoryListParams {
  page: number;
  token: string;
  rows?: number;
  depth: number; // 0 - 대분류, 1 - 중분류, 2 - 소분류
  parentUID: number; // 상위 분류가 있을 경우만 상위 분류의 UID값 - 대분류인 경우는 생략
}
export const initialEDCategoryListParams = {
  page: 1,
  token: "",
  rows: 20,
  depth: 0, // 0 - 대분류, 1 - 중분류, 2 - 소분류
  parentUID: 0, // 상위 분류가 있을 경우만 상위 분류의 UID값 - 대분류인 경우는 생략
  subCategories: [] as EDCategory[],
};
